import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";

import reducer from "@slices/index";

import { SERVER_PHASE } from "@stadium/constants";

const isDevelopment = process.env.NODE_ENV === "development";

const generateStore = configureStore({
  reducer,
  devTools: isDevelopment,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(isDevelopment && !SERVER_PHASE ? logger : []),
});

export type RootState = ReturnType<typeof generateStore.getState>;
export type AppDispatch = typeof generateStore.dispatch;

export default generateStore;
